/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section4title2Inputs */

const id_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Pengumpulan dan Pembaruan Data`)
};

const ms_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Pengumpulan dan Kemas Kini Data`)
};

const da_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Dataindsamling og Opdateringer`)
};

const de_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Datenerfassung und -aktualisierung`)
};

const en_us2_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Data Collection and Updates`)
};

const es_es2_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Recopilación y actualización de datos`)
};

const es_mx2_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Recopilación y actualización de datos`)
};

const fil_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Pagkolekta at Pag-update ng Data`)
};

const fr_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Collecte et mise à jour des données`)
};

const it_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Raccolta e aggiornamento dei dati`)
};

const hu_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Adatgyűjtés és frissítések`)
};

const nl_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Gegevensverzameling en updates`)
};

const no_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Datainnsamling og oppdateringer`)
};

const pl_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Gromadzenie i aktualizacja danych`)
};

const pt_br2_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Coleta e atualizações de dados`)
};

const pt_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Recolha e atualização de dados`)
};

const ro_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Colectarea și actualizarea datelor`)
};

const fi_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Tietojen keruu ja päivitykset`)
};

const sv_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Datainsamling och uppdateringar`)
};

const vi_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Thu thập và cập nhật dữ liệu`)
};

const tr_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Veri Toplama ve Güncellemeler`)
};

const cs_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Sběr dat a aktualizace`)
};

const bg_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Събиране на данни и актуализации`)
};

const ru_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Сбор данных и обновления`)
};

const uk_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Збір та оновлення даних`)
};

const ar_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. جمع البيانات وتحديثها`)
};

const hi_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. डेटा संग्रह`)
};

const th_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. การรวบรวมและอัปเดตข้อมูล`)
};

const ja_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. データ収集と更新`)
};

const zh_cn2_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. 数据收集与更新`)
};

const zh_hant1_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. 資料收集與更新`)
};

const ko_misc_fairuse_section4title2 = /** @type {(inputs: Misc_Fairuse_Section4title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. 데이터 수집 및 업데이트`)
};

/**
* | output |
* | --- |
* | "4. Data Collection and Updates" |
*
* @param {Misc_Fairuse_Section4title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section4title2 = /** @type {((inputs?: Misc_Fairuse_Section4title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section4title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section4title2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section4title2(inputs)
	if (locale === "da") return da_misc_fairuse_section4title2(inputs)
	if (locale === "de") return de_misc_fairuse_section4title2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section4title2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section4title2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section4title2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section4title2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section4title2(inputs)
	if (locale === "it") return it_misc_fairuse_section4title2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section4title2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section4title2(inputs)
	if (locale === "no") return no_misc_fairuse_section4title2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section4title2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section4title2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section4title2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section4title2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section4title2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section4title2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section4title2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section4title2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section4title2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section4title2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section4title2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section4title2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section4title2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section4title2(inputs)
	if (locale === "th") return th_misc_fairuse_section4title2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section4title2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section4title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section4title2(inputs)
	return ko_misc_fairuse_section4title2(inputs)
});
export { misc_fairuse_section4title2 as "misc.fairUse.section4Title" }